const isDevMode = process.env.NODE_ENV === 'development';

export default isDevMode;
